// Showcase Tech Badge Component
// Custom web component for displaying technology badges

import type { TechBadge } from "./showcase-config.ts";

class ShowcaseTechBadge extends HTMLElement {
  private config: TechBadge | null = null;

  connectedCallback() {
    this.render();
  }

  setConfig(config: TechBadge) {
    this.config = config;
    this.render();
  }

  private render() {
    if (!this.config) return;

    this.innerHTML = `
      <span class="tech-badge px-3 py-1 ${this.config.colorClass} rounded-full text-sm font-medium">
        ${this.config.name}
      </span>
    `;
  }
}

customElements.define("showcase-tech-badge", ShowcaseTechBadge);

export { ShowcaseTechBadge };

